import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FormFieldWrapperComponent } from '../form-field-wrapper/form-field-wrapper.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { NgForOf, NgIf } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { SharedModule } from 'primeng/api';
import { TabMenuModule } from 'primeng/tabmenu';
import { TreeSelectModule } from 'primeng/treeselect';

@Component({
  selector: 'app-feature-meta-form',
  standalone: true,
  imports: [
    ButtonModule,
    CheckboxModule,
    DividerModule,
    DropdownModule,
    EditorModule,
    FormFieldWrapperComponent,
    InputNumberModule,
    InputSwitchModule,
    InputTextModule,
    NgForOf,
    NgIf,
    PaginatorModule,
    ReactiveFormsModule,
    SharedModule,
    TabMenuModule,
    TreeSelectModule,
  ],
  templateUrl: './feature-meta-form.component.html',
  styleUrl: './feature-meta-form.component.scss',
})
export class FeatureMetaFormComponent implements OnInit {
  @Input() featureToEdit: AbstractControl | null = null;
  @Output() featureUpdated = new EventEmitter<FormGroup>();
  @Output() closeMetaForm = new EventEmitter();

  form: FormGroup = new FormGroup({});
  init = false;

  editorProperties = [
    {
      key: 'description',
      label: 'Beschreibung',
    },
    {
      key: 'address',
      label: 'Adresse',
    },
    {
      key: 'contact',
      label: 'Kontakt',
    },
    {
      key: 'information',
      label: 'Weitere Informationen',
    },
  ];

  constructor(private fb: FormBuilder) {}

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * It checks if `featureToEdit` exists and is an instance of FormGroup.
   * If the conditions are met, it initializes the meta form by calling the `initializeMetaForm` method.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    if (this.featureToEdit && this.featureToEdit instanceof FormGroup) {
      this.initializeMetaForm(this.featureToEdit);
    }
  }

  /**
   * Handles the submission of a form, emitting an event with the form data if it exists and is a valid FormGroup.
   *
   * @return {void} Does not return a value.
   */
  onSubmit(): void {
    if (this.featureToEdit && this.featureToEdit instanceof FormGroup) {
      this.featureUpdated.emit(this.featureToEdit);
    }
  }

  /**
   * Initializes the meta-form with the provided FormGroup and sets the initialization state.
   *
   * @param {FormGroup} featureToEdit - The FormGroup instance to be assigned to the meta-form.
   * @return {void} This method does not return a value.
   */
  private initializeMetaForm(featureToEdit: FormGroup): void {
    this.form = featureToEdit;
    this.init = true;
  }
}
